import Mock from "mockjs";

//查詢
//新增
Mock.mock(/\/api\/insurancedata\/findByCondition/, "post", function(options){
    var data = options;
    console.log(JSON.stringify(data));
    return Mock.mock({
        status: 200,
        message: "mock create success",
        result: true,
        list: [
            {
                id:1,
                "agency_company": {
                    "id": 1,
                    "name": "ABCD"
                },
                "insurance_company": {
                    "id": 3,
                    "name": "忠意"
                },
                "insurance_product": {
                    "id": 20,
                    "name": "尊安保險"
                },
                "salesman": {
                    "id": 1,
                    "name": "陳小日"
                },
                "insurance_number": "AAAAA01",
                "holder": {
                    "id": 1,
                    "name": "江溫妮",
                    "eng_name": "Winnie Chiang",
                    "birthday": "1980-04-12",
                    "sex": "female",
                    "city": "台北市",
                    "township": "中山區",
                    "address": "樂群二路267號"
                },
                "insured_date": "2022-02-20",
                "contribution_period": 6,
                "period_fee": 1234.99,
                "currency_type": "USD",
                "beneficiary_name": "謝先生",
                "second_holder_name": "謝小弟",
                "remarks": "Test123"
            },
            {
                id: 2,
                "agency_company": {
                    "id": 1,
                    "name": "ABCD"
                },
                "insurance_company": {
                    "id": 3,
                    "name": "忠意"
                },
                "insurance_product": {
                    "id": 20,
                    "name": "尊安保險"
                },
                "salesman": {
                    "id": 1,
                    "name": "陳小日"
                },
                "insurance_number": "ABAAA01",
                "holder": {
                    "id": 1,
                    "name": "江溫妮",
                    "eng_name": "Winnie Chiang",
                    "birthday": "1980-04-12",
                    "sex": "female",
                    "city": "台北市",
                    "township": "中山區",
                    "address": "樂群二路267號"
                },
                "insured_date": "2021-02-20",
                "contribution_period": 5,
                "period_fee": 3001.99,
                "currency_type": "USD",
                "beneficiary_name": "謝先生",
                "second_holder_name": "謝小弟",
                "remarks": "Test123"
            }
        ]
    });
})

//刪除
Mock.mock(/\/api\/insurancedata/, "delete", function(options){
    return Mock.mock({
    status: 200,
    message: "mock delete success",
    result: true,
    insurance_data: options.body
    });
})

//新增
Mock.mock(/\/api\/insurancedata/, "post", function(options){
    return Mock.mock({
    status: 200,
    message: "mock create success",
    result: true,
    insurance_data: options.body
    });
})

//更新
Mock.mock(/\/api\/insurancedata/, "put", function(options){
    return Mock.mock({
    status: 200,
    message: "mock update success",
    result: true,
    insurance_data: options.body
    });
})


//getAll:/api/tutorials
Mock.mock(/\/api\/insurancedata/, "get", function(options) {
    
  console.log(options);
  //如果沒有帶參數，就是抓全部
  var urlAry = options.url.split('/api/insurancedata')
  //console.log(urlAry)
  if (urlAry[1].length > 1) {
    //get:/api/tutorials/${id}
    //如果是用return, 一定要回傳Mock.mock()
    return Mock.mock({
        "result": true,
        "message": "查詢成功",
        "item": {
            "id": 2,
            "agency_company": {
                "id": 1,
                "name": "ABCD"
            },
            "insurance_company": {
                "id": 3,
                "name": "忠意"
            },
            "insurance_product": {
                "id":20,
                "name": "尊安保險"
            },
            "salesman": {
                "id": 1,
                "name": "陳小日"
            },
            "insurance_number": "AAAAA01",
            "holder": {
                "id": 1,
                "name": "江溫妮",
                "eng_name": "Winnie Chiang",
                "birthday": "1980-04-12",
                "sex": "female",
                "city": "台北市",
                "township": "中山區",
                "address": "樂群二路267號"
            },
            "insured_date": "2021-02-20",
            "contribution_period": 5,
            "period_fee": 3001.99,
            "currency_type": "USD",
            "beneficiary_name": "謝先生",
            "second_holder_name": "謝小弟",
            "remarks": "Test123"
        }
    });
  } else {
    //get All:/api/tutorials/
    return Mock.mock( {
      status: 200,
      message: "mock get all success",
      "list": [
        {
            id:1,
            "agency_company": {
                "id": 1,
                "name": "ABCD"
            },
            "insurance_company": {
                "id": 1,
                "name": "AXA"
            },
            "insurance_product": {
                "id": 1,
                "name": "保險計劃1"
            },
            "salesman": {
                "id": 1,
                "name": "陳小日"
            },
            "insurance_number": "AAAAA01",
            "holder": {
                "id": 1,
                "name": "江溫妮",
                "eng_name": "Winnie Chiang",
                "birthday": "1980-04-12",
                "sex": "female",
                "city": "台北市",
                "township": "中山區",
                "address": "樂群二路267號"
            },
            "insured_date": "2022-02-20",
            "contribution_period": 6,
            "period_fee": 1234.99,
            "currency_type": "USD",
            "beneficiary_name": "謝先生",
            "second_holder_name": "謝小弟",
            "remarks": "Test123"
        },
        {
            id: 2,
            "agency_company": {
                "id": 1,
                "name": "ABCD"
            },
            "insurance_company": {
                "id": 1,
                "name": "AXA"
            },
            "insurance_product": {
                "id": 1,
                "name": "保險計劃2"
            },
            "salesman": {
                "id": 1,
                "name": "陳小日"
            },
            "insurance_number": "ABAAA01",
            "holder": {
                "id": 1,
                "name": "江溫妮",
                "eng_name": "Winnie Chiang",
                "birthday": "1980-04-12",
                "sex": "female",
                "city": "台北市",
                "township": "中山區",
                "address": "樂群二路267號"
            },
            "insured_date": "2021-02-20",
            "contribution_period": 5,
            "period_fee": 3001.99,
            "currency_type": "USD",
            "beneficiary_name": "謝先生",
            "second_holder_name": "謝小弟",
            "remarks": "Test123"
        }
    ]
    });
  }
});